export { AnchorNavigation as UNSAFE_AnchorNavigation } from './AnchorNavigation'
export type { AnchorNavigationProps as UNSAFE_AnchorNavigationProps } from './AnchorNavigation.types'
